import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './ot-security.css'

const OTSecurity = (props) => {
  return (
    <div className="ot-security-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="OT-Security - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/ot-security"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section ot-security-hero-section">
        <div className="hero-background">
          <img
            alt="Industrial control systems and automation"
            src="https://images.pexels.com/photos/13068887/pexels-photo-13068887.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="ot-security-hero-content hero-content">
          <div className="ot-security-hero-content-inner">
            <div className="ot-security-hero-badge">
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewbox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>OT Security Excellence</span>
            </div>
            <h1 className="hero-title ot-security-hero-title">
              Protect Your Operational Technology Infrastructure
            </h1>
            <p className="ot-security-hero-subtitle hero-subtitle">
              Comprehensive OT security assessments and resilience planning for
              industrial control systems, SCADA networks, and critical
              infrastructure. Safeguard your operations against evolving cyber
              threats.
            </p>
            <div className="ot-security-hero-actions">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#services">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Services</span>
                </div>
              </a>
            </div>
            <div className="ot-security-hero-stats">
              <div className="ot-security-hero-stat-item">
                <span className="ot-security-hero-stat-value">5+</span>
                <span className="ot-security-hero-stat-label">
                  OT Assets Secured
                </span>
              </div>
              <div className="ot-security-hero-stat-item">
                <span className="ot-security-hero-stat-value">99.8%</span>
                <span className="ot-security-hero-stat-label">
                  Threat Detection Rate
                </span>
              </div>
              <div className="ot-security-hero-stat-item">
                <span className="ot-security-hero-stat-value">24/7</span>
                <span className="ot-security-hero-stat-label">
                  Monitoring Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ot-security-features-section">
        <div className="features-container">
          <div className="features-header ot-security-features-header">
            <h2 className="section-title">Understanding OT Security Threats</h2>
            <p className="section-subtitle">
              Operational technology environments face unique cybersecurity
              challenges that require specialized expertise and tailored
              solutions
            </p>
          </div>
          <div className="ot-security-features-grid">
            <div className="features-card">
              <div className="features-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-card-title">OT Security Risks</h3>
              <p className="section-content">
                Legacy systems, air-gap vulnerabilities, convergence with IT
                networks, and sophisticated nation-state threats targeting
                critical infrastructure create complex attack surfaces.
              </p>
              <ul className="features-list">
                <li>
                  <span>Ransomware targeting industrial systems</span>
                </li>
                <li>
                  <span>Supply chain vulnerabilities</span>
                </li>
                <li>
                  <span>Insider threats and credential abuse</span>
                </li>
                <li>
                  <span>Protocol exploitation and manipulation</span>
                </li>
              </ul>
            </div>
            <div className="features-card">
              <div className="features-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-card-title">Assessment Scope</h3>
              <p className="section-content">
                Comprehensive evaluation of network architecture, device
                configurations, access controls, patch management, and
                operational protocols across your entire OT ecosystem.
              </p>
              <ul className="features-list">
                <li>
                  <span>Network segmentation analysis</span>
                </li>
                <li>
                  <span>Device inventory and firmware audits</span>
                </li>
                <li>
                  <span>Access control policy review</span>
                </li>
                <li>
                  <span>Change management procedures</span>
                </li>
              </ul>
            </div>
            <div className="features-card">
              <div className="features-icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-card-title">Resilience Goals</h3>
              <p className="section-content">
                Build robust defense-in-depth strategies, incident response
                capabilities, and recovery procedures to maintain operational
                continuity under adversarial conditions.
              </p>
              <ul className="features-list">
                <li>
                  <span>Zero-trust architecture implementation</span>
                </li>
                <li>
                  <span>Rapid incident detection and response</span>
                </li>
                <li>
                  <span>Business continuity planning</span>
                </li>
                <li>
                  <span>Disaster recovery validation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="ot-security-services-section">
        <div className="services-container">
          <div className="ot-security-services-header services-header">
            <h2 className="section-title">OT Security Assessment Offerings</h2>
            <p className="section-subtitle">
              Comprehensive evaluation across network infrastructure, device
              security, operational processes, and governance frameworks
            </p>
          </div>
          <div className="ot-security-services-grid">
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-card-title">
                Network Security Assessment
              </h3>
              <p className="section-content">
                Evaluate network segmentation, firewall rules, intrusion
                detection systems, and data flow patterns across IT/OT
                boundaries to identify weaknesses and implement security zones.
              </p>
            </div>
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-card-title">
                Device &amp; Endpoint Security
              </h3>
              <p className="section-content">
                Comprehensive inventory and vulnerability analysis of PLCs,
                RTUs, HMIs, SCADA systems, and IIoT devices including firmware
                assessment and hardening recommendations.
              </p>
            </div>
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="services-card-title">Process Security Review</h3>
              <p className="section-content">
                Analyze operational workflows, change management procedures,
                patch deployment strategies, and maintenance protocols to ensure
                security doesn&apos;t compromise availability.
              </p>
            </div>
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="services-card-title">Access Control Audit</h3>
              <p className="section-content">
                Review user authentication mechanisms, privileged access
                management, role-based controls, and third-party vendor access
                to minimize insider threat exposure.
              </p>
            </div>
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-card-title">Governance Framework</h3>
              <p className="section-content">
                Establish security policies, risk management frameworks,
                compliance mapping, and security awareness programs tailored to
                OT operational requirements.
              </p>
            </div>
            <div className="services-card">
              <div className="services-icon">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-card-title">
                Incident Response Planning
              </h3>
              <p className="section-content">
                Develop and test incident response playbooks, communication
                protocols, and recovery procedures specific to OT environments
                and operational impact scenarios.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-section ot-security-process-section">
        <div className="process-container">
          <div className="process-header ot-security-process-header">
            <h2 className="section-title">OT Resilience Validation Process</h2>
            <p className="section-subtitle">
              Adversary simulation, tabletop exercises, and realistic attack
              scenarios to test your defenses and response capabilities
            </p>
          </div>
          <div className="ot-security-process-steps">
            <div className="ot-security-process-step">
              <div className="ot-security-process-step-number">
                <span>01</span>
              </div>
              <div className="ot-security-process-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 6v6l4 2m4-2v5m0 4h.01"></path>
                    <path d="M21.25 8.2A10 10 0 1 0 16 21.16"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ot-security-process-step-title">
                Threat Intelligence Gathering
              </h3>
              <p className="section-content">
                Analyze industry-specific threat actors, attack patterns, and
                vulnerabilities relevant to your operational environment and
                technology stack.
              </p>
            </div>
            <div className="ot-security-process-step">
              <div className="ot-security-process-step-number">
                <span>02</span>
              </div>
              <div className="ot-security-process-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
                    <circle r="3" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="ot-security-process-step-title">
                Scenario Development
              </h3>
              <p className="section-content">
                Design realistic attack scenarios including ransomware
                deployment, supply chain compromise, and targeted sabotage
                attempts against critical systems.
              </p>
            </div>
            <div className="ot-security-process-step">
              <div className="ot-security-process-step-number">
                <span>03</span>
              </div>
              <div className="ot-security-process-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="m21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="ot-security-process-step-title">
                Tabletop Exercises
              </h3>
              <p className="section-content">
                Facilitate interactive workshops with key stakeholders to walk
                through incident scenarios, test decision-making processes, and
                identify gaps in response procedures.
              </p>
            </div>
            <div className="ot-security-process-step">
              <div className="ot-security-process-step-number">
                <span>04</span>
              </div>
              <div className="ot-security-process-step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="ot-security-process-step-title">
                Live Simulation
              </h3>
              <p className="section-content">
                Execute controlled adversary simulations in isolated test
                environments to validate detection capabilities, response times,
                and recovery procedures without operational disruption.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="ot-security-timeline-section">
        <div className="ot-security-timeline-container">
          <div className="ot-security-timeline-header">
            <h2 className="section-title">
              Compliance &amp; Standards Framework
            </h2>
            <p className="section-subtitle">
              Our assessments map to industry-leading OT/ICS security standards
              and regulatory requirements
            </p>
          </div>
          <div className="ot-security-timeline-track">
            <div className="ot-security-timeline-item">
              <div className="timeline-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-security-timeline-content">
                <h3 className="ot-security-timeline-title">IEC 62443</h3>
                <p className="ot-security-timeline-description">
                  Industrial automation and control systems security standard
                  covering network segmentation, access control, and secure
                  development lifecycle.
                </p>
                <div className="timeline-deliverables">
                  <span className="timeline-badge">Gap Analysis</span>
                  <span className="timeline-badge">
                    Zone &amp; Conduit Design
                  </span>
                  <span className="timeline-badge">
                    Security Levels Assessment
                  </span>
                </div>
              </div>
            </div>
            <div className="ot-security-timeline-item">
              <div className="timeline-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-security-timeline-content">
                <h3 className="ot-security-timeline-title">NIST CSF for OT</h3>
                <p className="ot-security-timeline-description">
                  Cybersecurity framework adapted for operational technology
                  environments with focus on identify, protect, detect, respond,
                  and recover functions.
                </p>
                <div className="timeline-deliverables">
                  <span className="timeline-badge">Maturity Assessment</span>
                  <span className="timeline-badge">Risk Prioritization</span>
                  <span className="timeline-badge">Implementation Roadmap</span>
                </div>
              </div>
            </div>
            <div className="ot-security-timeline-item">
              <div className="timeline-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <div className="ot-security-timeline-content">
                <h3 className="ot-security-timeline-title">NERC CIP</h3>
                <p className="ot-security-timeline-description">
                  Critical infrastructure protection standards for bulk electric
                  system operators covering asset identification, security
                  management, and incident reporting.
                </p>
                <div className="timeline-deliverables">
                  <span className="timeline-badge">Compliance Audit</span>
                  <span className="timeline-badge">
                    BES Cyber Assets Review
                  </span>
                  <span className="timeline-badge">Evidence Collection</span>
                </div>
              </div>
            </div>
            <div className="ot-security-timeline-item">
              <div className="timeline-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76M12 8v4m0 4h.01"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="ot-security-timeline-content">
                <h3 className="ot-security-timeline-title">
                  ISA/IEC Standards
                </h3>
                <p className="ot-security-timeline-description">
                  Comprehensive standards for industrial automation including
                  SCADA security, safety instrumented systems, and fieldbus
                  technologies.
                </p>
                <div className="timeline-deliverables">
                  <span className="timeline-badge">Technical Evaluation</span>
                  <span className="timeline-badge">Protocol Analysis</span>
                  <span className="timeline-badge">Best Practice Guide</span>
                </div>
              </div>
            </div>
            <div className="ot-security-timeline-item">
              <div className="timeline-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="ot-security-timeline-content">
                <h3 className="ot-security-timeline-title">NIS2 Directive</h3>
                <p className="ot-security-timeline-description">
                  European Union cybersecurity requirements for essential and
                  important entities including critical infrastructure and
                  supply chain resilience.
                </p>
                <div className="timeline-deliverables">
                  <span className="timeline-badge">
                    Applicability Assessment
                  </span>
                  <span className="timeline-badge">Incident Response Plan</span>
                  <span className="timeline-badge">Supply Chain Mapping</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ot-security-casestudies-section">
        <div className="ot-security-casestudies-wrapper">
          <div className="casestudies-header ot-security-casestudies-header">
            <div className="casestudies-header-content">
              <h2 className="section-title">OT Security Success Stories</h2>
              <p className="section-subtitle">
                Real-world engagements demonstrating our expertise in protecting
                operational technology environments
              </p>
            </div>
          </div>
          <div className="casestudies-rail">
            <div className="ot-security-casestudies-card">
              <div className="ot-security-casestudies-image">
                <img
                  alt="Advanced industrial automation machinery"
                  src="https://images.pexels.com/photos/18471551/pexels-photo-18471551.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="ot-security-casestudies-overlay"></div>
              </div>
              <div className="ot-security-casestudies-content">
                <div className="casestudies-meta">
                  <span className="ot-security-casestudies-industry">
                    Manufacturing
                  </span>
                  <span className="casestudies-duration">6 Months</span>
                </div>
                <h3 className="ot-security-casestudies-title">
                  Global Automotive Manufacturer
                </h3>
                <p className="section-content">
                  Secured 250+ production line PLCs and SCADA systems across 12
                  facilities, implementing network segmentation and zero-trust
                  architecture. Reduced attack surface by 87% and achieved IEC
                  62443 Level 3 compliance.
                </p>
                <div className="casestudies-results">
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      87%
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Risk Reduction
                    </span>
                  </div>
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      250+
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Assets Secured
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ot-security-casestudies-card">
              <div className="ot-security-casestudies-image">
                <img
                  alt="Industrial facility with advanced technology"
                  src="https://images.pexels.com/photos/5953729/pexels-photo-5953729.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="ot-security-casestudies-overlay"></div>
              </div>
              <div className="ot-security-casestudies-content">
                <div className="casestudies-meta">
                  <span className="ot-security-casestudies-industry">
                    Energy
                  </span>
                  <span className="casestudies-duration">9 Months</span>
                </div>
                <h3 className="ot-security-casestudies-title">
                  Regional Power Utility
                </h3>
                <p className="section-content">
                  Comprehensive NERC CIP compliance assessment and remediation
                  for generation and transmission infrastructure. Implemented
                  continuous monitoring, incident response playbooks, and
                  achieved full compliance certification.
                </p>
                <div className="casestudies-results">
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      100%
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      NERC CIP Compliance
                    </span>
                  </div>
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      24/7
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Monitoring Uptime
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ot-security-casestudies-card">
              <div className="ot-security-casestudies-image">
                <img
                  alt="Industrial pipeline control systems"
                  src="https://images.pexels.com/photos/5658852/pexels-photo-5658852.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="ot-security-casestudies-overlay"></div>
              </div>
              <div className="ot-security-casestudies-content">
                <div className="casestudies-meta">
                  <span className="ot-security-casestudies-industry">
                    Oil &amp; Gas
                  </span>
                  <span className="casestudies-duration">12 Months</span>
                </div>
                <h3 className="ot-security-casestudies-title">
                  Pipeline Operations Company
                </h3>
                <p className="section-content">
                  Red team assessment identified 23 critical vulnerabilities in
                  SCADA networks and field devices. Implemented defense-in-depth
                  strategy with DMZ architecture, multi-factor authentication,
                  and encrypted communications.
                </p>
                <div className="casestudies-results">
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      23
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Vulnerabilities Fixed
                    </span>
                  </div>
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      99.9%
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      System Availability
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ot-security-casestudies-card">
              <div className="ot-security-casestudies-image">
                <img
                  alt="Modern industrial facility equipment"
                  src="https://images.pexels.com/photos/4440200/pexels-photo-4440200.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
                <div className="ot-security-casestudies-overlay"></div>
              </div>
              <div className="ot-security-casestudies-content">
                <div className="casestudies-meta">
                  <span className="ot-security-casestudies-industry">
                    Chemical
                  </span>
                  <span className="casestudies-duration">8 Months</span>
                </div>
                <h3 className="ot-security-casestudies-title">
                  Chemical Processing Facility
                </h3>
                <p className="section-content">
                  Safety-first OT security assessment for critical process
                  controls managing hazardous materials. Validated safety
                  instrumented systems integrity, implemented secure remote
                  access, and established incident response protocols.
                </p>
                <div className="casestudies-results">
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      Zero
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Safety Incidents
                    </span>
                  </div>
                  <div className="ot-security-casestudies-metric">
                    <span className="ot-security-casestudies-metric-value">
                      ISO 27001
                    </span>
                    <span className="ot-security-casestudies-metric-label">
                      Certified
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="ot-security-cta-section cta-section">
        <div className="cta-background">
          <img
            alt="Cybersecurity technology background"
            src="https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="ot-security-cta-image"
          />
          <div className="cta-overlay"></div>
        </div>
        <div className="ot-security-cta-content">
          <div className="cta-left">
            <h2 className="section-title">
              Secure Your OT Infrastructure Today
            </h2>
            <p className="section-content">
              Don&apos;t wait for a security incident to expose vulnerabilities
              in your operational technology environment. Our experts are ready
              to assess your OT security posture and build resilience into your
              critical infrastructure.
            </p>
            <ul className="cta-benefits">
              <li className="ot-security-cta-benefit-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Comprehensive OT security assessment</span>
              </li>
              <li className="ot-security-cta-benefit-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Industry-leading compliance mapping</span>
              </li>
              <li className="ot-security-cta-benefit-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Actionable remediation roadmap</span>
              </li>
              <li className="ot-security-cta-benefit-item">
                <svg
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewbox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>24/7 expert support and monitoring</span>
              </li>
            </ul>
            <a href="#contact-expert">
              <div className="ot-security-thq-btn-elm3 btn-primary btn-xl btn">
                <span>Schedule Consultation</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <div className="ot-security-container2">
        <div className="ot-security-container3">
          <Script
            html={`<script defer data-name="casestudies-rail-scroll">
(function(){
  const casestudiesRail = document.querySelector(".casestudies-rail")

  if (casestudiesRail) {
    let isDown = false
    let startX
    let scrollLeft

    casestudiesRail.addEventListener("mousedown", (e) => {
      isDown = true
      casestudiesRail.style.cursor = "grabbing"
      startX = e.pageX - casestudiesRail.offsetLeft
      scrollLeft = casestudiesRail.scrollLeft
    })

    casestudiesRail.addEventListener("mouseleave", () => {
      isDown = false
      casestudiesRail.style.cursor = "grab"
    })

    casestudiesRail.addEventListener("mouseup", () => {
      isDown = false
      casestudiesRail.style.cursor = "grab"
    })

    casestudiesRail.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - casestudiesRail.offsetLeft
      const walk = (x - startX) * 2
      casestudiesRail.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <div className="ot-security-container4">
        <div className="ot-security-container5">
          <Script
            html={`<script defer data-name="timeline-scroll-indicator">
(function(){
  const timelineTrack = document.querySelector(".timeline-track")

  if (timelineTrack) {
    let isDown = false
    let startX
    let scrollLeft

    timelineTrack.addEventListener("mousedown", (e) => {
      isDown = true
      timelineTrack.style.cursor = "grabbing"
      startX = e.pageX - timelineTrack.offsetLeft
      scrollLeft = timelineTrack.scrollLeft
    })

    timelineTrack.addEventListener("mouseleave", () => {
      isDown = false
      timelineTrack.style.cursor = "grab"
    })

    timelineTrack.addEventListener("mouseup", () => {
      isDown = false
      timelineTrack.style.cursor = "grab"
    })

    timelineTrack.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - timelineTrack.offsetLeft
      const walk = (x - startX) * 2
      timelineTrack.scrollLeft = scrollLeft - walk
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <div className="ot-security-container6">
        <div className="ot-security-container7">
          <Script
            html={`<script defer data-name="scroll-animations">
(function(){
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const animateOnScroll = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }

  const observer = new IntersectionObserver(animateOnScroll, observerOptions)

  const elementsToAnimate = document.querySelectorAll(".features-card, .services-card, .process-step, .timeline-item, .casestudies-card, .team-card")

  elementsToAnimate.forEach((element) => {
    element.style.opacity = "0"
    element.style.transform = "translateY(20px)"
    element.style.transition = "opacity 0.5s ease, transform 0.5s ease"
    observer.observe(element)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default OTSecurity
